
import React, { useEffect } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
  } from "@material-ui/core";
import Swal from "sweetalert2";

export const DialogAddChoice = ({...props})=>{
    const [disable, setDisable] = React.useState(false)
    const [valueField, setValueField] = React.useState({})
    useEffect(()=>{
      setValueField({list_name:props.choice})
      setDisable(false)
    },[props.open])
    useEffect(()=>{
      let temp = false
      for(let i=0;i<Object.values(valueField)?.length;i++){
        if(Object.values(valueField)[i].valid){
          temp = true
        }
      }
      setDisable(temp)
    },[valueField])

    return (
      <Dialog
        key={"form-dialog"+props.choice}
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="form-dialog-title"
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <DialogTitle id="form-dialog-title">
          {props.openEdit ? "Edit choice" : "Add new choice to " + props.choice}
        </DialogTitle>
        <DialogContent>
          <form id={props.choice + "form-content"}>
            {props.choice ? (
              <input
                type="hidden"
                name="list_name"
                value={props.choice}
              />
            ) : (
              <TextField
                error={valueField['list_name']?.valid || valueField["list_name"]?.value && !valueField?.["list_name"]?.value?.match(/^[a-zA-Z0-9_-]+$/)}
                required
                margin="dense"
                name="list_name"
                key={"list_name"+props.choice}
                label="List name"
                fullWidth
                autoFocus
                defaultValue={`list_choices_${new Date().getTime()}`}
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                }}
                onChange={(e)=>{
                  let validListName = Object.keys(props.choicesListNew).indexOf(e.target.value) >-1
                  let tempState = valueField
                  tempState = {...tempState,...{list_name : {value : e.target.value, valid : validListName}}}
                  setValueField(tempState)
                }}
                helperText={valueField['list_name']?.valid ? `List name ${valueField['list_name']?.value} already exists!` : "Do not enter spaces or special characters"}
              />
            )}
            {props.choiceListRender.map((field) => {
              if (Array.isArray(field)) {
                if (
                  field[0] === "name" ||
                  field[0].indexOf("label") > -1
                ) {
                  return (
                    <TextField
                      error={valueField[field[0]]?.valid}
                      required={field[0] === "name" ? true : false}
                      margin="dense"
                      name={field[0]}
                      key={props.choice+field[0]}
                      label={field[0] === "name" ? "Value" : field[0]}
                      fullWidth
                      defaultValue={field[1]}
                      onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                      }}
                      onChange={(e)=>{
                        let invalid = false
                        if(field[0] === "name"){
                          props.choicesListNew[props.choice]?.forEach(element => {
                            if(element.name === e.target.value && e.target.value !== field[1]){
                              invalid = true
                            }
                          });
                        }
                        let tempState = valueField
                        tempState = {...tempState,...{[field[0]] : {value : e.target.value, valid : invalid}}}
                        setValueField(tempState)
                      }}
                      helperText={valueField[field[0]]?.valid ? `Value ${valueField[field[0]]?.value} already exists in the list ${valueField['list_name']}!` : ""}
                    />
                  );
                }
                return <></>;
              } else {
                if (field === "name" || field.indexOf("label") > -1) {
                  return (
                    <TextField
                      error={valueField[field]?.valid || field == "name" && valueField[field]?.value && !valueField?.[field]?.value?.match(/^[a-zA-Z0-9_-]+$/)}
                      required={field === "name" ? true : false}
                      margin="dense"
                      name={field}
                      key={props.choice+field}
                      label={field === "name" ? "Value" : field}
                      fullWidth
                      onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                      }}
                      onChange={(e)=>{
                        let invalid = false
                        if(field === "name"){
                          props.choicesListNew[props.choice]?.forEach(element => {
                            if(element.name === e.target.value){
                              invalid = true
                            }
                          });
                        }
                        let tempState = valueField
                        tempState = {...tempState,...{[field] : {value : e.target.value, valid : invalid}}}
                        setValueField(tempState)
                        
                      }}
                      helperText={valueField[field]?.valid ? `Value ${valueField[field]?.value} already exists in the list ${valueField['list_name']}!` : field === "name" ? "Do not enter spaces or special characters" : ""}
                    />
                  );
                }
                return [];
              }
            })}
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e)=>{
            props.handleClose()
            e.preventDefault()
            e.stopPropagation()
          }} color="primary">
            Cancel
          </Button>
          <Button
            disabled={disable}
            type="submit"
            onClick={(e) => {
              if(document.querySelector("input[name='list_name']").value?.length === 0 || !document.querySelector("input[name='list_name']").value.match(/^[a-zA-Z0-9_-]+$/)){
                Swal.fire(
                  {title : 'Warning!',
                  text : 'List name blank or contain spaces, special characters',
                  icon: 'warning',
                  customClass: {
                    container: 'custom-container-swal'
                  }}
                )
              }else if(document.querySelector("input[name='name']").value?.length === 0 || !document.querySelector("input[name='name']").value.match(/^[a-zA-Z0-9_-]+$/)){
                Swal.fire(
                  {title : 'Warning!',
                  text : 'Value blank or contain spaces, special characters',
                  icon: 'warning',
                  customClass: {
                    container: 'custom-container-swal'
                  }}
                )
              }else{
                if (props.openEdit) {
                  props.handleEditChoice(props.choicesListNew);
                } else {
                  props.handleAddNewChoice(props.choicesListNew);
                }
              }
             
              e.preventDefault()
              e.stopPropagation()
            }}
            color="primary"
          >
            {props.openEdit ? "Edit" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }